import React, { useEffect, useState, useMemo, useCallback } from "react";
import { getSessionsByDateRange } from "../../Services/CartApi";
import { useOrganisations } from "../../Auth/useOrganisations";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactPaginate from "react-paginate";
import GifLoader from "../../Components/loader";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  getAllCashJournals,
  getCashJournalById,
  getJournalReport,
  updateCashJournal,
} from "../../Services/JournalApi";
import { useParams } from "react-router-dom";
import {
  formadate,
  formatDate,
  formatDateAndTime,
  formatTime,
} from "../../Helpers/Helpers";
import { getParametrageCaisse } from "../../Services/ParametrageApi";
import { useUser } from "../../Auth/useUser";
import swal from "sweetalert";
import OrderDetailsModal from "../../Components/OrderDetails";

const MODAL_STYLE = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxWidth: "90vw",
  bgcolor: "white",
  p: 4,
  borderRadius: 2,
};

const ROWS_PER_PAGE = 10;
const REFRESH_INTERVAL = 30000; // 30 seconds

const getOrderColor = (status) => {
  switch (status) {
    case "Annulée":
      return "primary";
    case "Nouveau":
      return "warning";
    case "Livrée":
      return "success";
    default:
      return "danger";
  }
};

function JournalCaisse() {
  const { t, i18n } = useTranslation();
  let { id } = useParams();

  const [transactions, settransactions] = useState([]);
  const [journal, setJournal] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [displayedCart, setDisplayedCart] = useState(null);
  const [filterTable, setFilterTable] = useState(0);
  const [currency, setCurrency] = useState(""); // Default currency, update as needed
  const [parametrage, setParametrage] = useState();

  const [organisations, setOrganisations, usedOrganisations] =
    useOrganisations();

  // Filtered and paginated data

  // Load sessions
  const loadSessions = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getJournalReport(id);
      const responsejournal = await getCashJournalById(id);
      getParametrageCaisse(usedOrganisations).then((res) => {
        const success = res.data.success;
        if (success === "0") {
          alert("error");
        } else {
          setParametrage(res.data.data);
        }
      });

      // response.data is now the flat sorted timeline array
      settransactions(Array.isArray(response.data) ? response.data : []);

      if (responsejournal.data.success !== "0") {
        setJournal(responsejournal.data.data);
      }
    } catch (error) {
      console.error("Error loading sessions:", error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  // Initial load and periodic refresh
  useEffect(() => {
    loadSessions();
    // Remove the interval if automatic refresh isn't critical
    // const interval = setInterval(loadSessions, REFRESH_INTERVAL);
    // return () => clearInterval(interval);
  }, [loadSessions]);

  // Calculate unique tables for filter dropdown
  const rows = useMemo(() => {
    if (!transactions || !transactions.length) return [];

    return transactions.map((item) => {
      if (item._type === "credit_payment") {
        return {
          _type: "credit_payment",
          _date: item._date,
          sessionCode: item.code,
          table_number: null,
          date: item._date,
          amount: item.amount,
          caissier: item.caissier_id?.nom || "-",
          serveur: "-",
          client: item.client_id?.name || "-",
          payment_method: item.payment_method,
          orders: [],
          payments: [],
        };
      }
      // session
      // session
      console.log("item", item.client.name);
      return {
        _type: "session",
        sessionCode: item.code,
        table_number: item.table?.table_number,
        date: item.start_time,
        amount: item.total_amount,
        caissier: item.caissier?.nom || "-",
        serveur: item.serveur?.nom || "-",
        client: item.client?.name || "-", // ← add this
        orders: item.orders || [],
        payments: item.payments || [],
        _raw: item,
      };
    });
  }, [transactions]);

  const totals = useMemo(() => {
    const result = {
      cash: 0,
      creditcard: 0,
      cheque: 0,
      giftcard: 0,
      credit_payment: 0,
      recette: 0,
    };

    rows.forEach((row) => {
      if (row._type === "credit_payment") {
        // cash entering the drawer from credit repayment
        if (row.payment_method === "cash") result.cash += row.amount;
        else if (row.payment_method === "creditcard")
          result.creditcard += row.amount;
        else if (row.payment_method === "cheque") result.cheque += row.amount;
        result.credit_payment += row.amount;
        return;
      }
      row.payments.forEach((payment) => {
        if (
          payment.payment_method &&
          result[payment.payment_method] !== undefined
        ) {
          result[payment.payment_method] += payment.amount - payment.rendu;
        }
      });
      result.recette += row.amount;
    });

    return result;
  }, [rows]);
  const fondInitial = journal?.fond_initial || 0;
  const fondFinal = journal?.fond_final || 0;

  const totalCaisse = fondInitial + totals.cash;
  const ecartAuto =
    parametrage && parametrage.clotureAllFund
      ? fondFinal - totalCaisse
      : totalCaisse - fondFinal;

  // money found by admin
  const [moneyFound, setMoneyFound] = useState(ecartAuto);
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    setMoneyFound(ecartAuto.toFixed(3));
    setIsTyping(false);
  }, [ecartAuto]);
  const handleKeyDown = (e) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];

    if (!isTyping && !allowedKeys.includes(e.key)) {
      // First key press replaces default value
      setMoneyFound(e.key);
      setIsTyping(true);
      e.preventDefault();
    }
  };

  const ecart = moneyFound - ecartAuto;
  const handleMoneyFoundChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      // If input is emptied, reset to default
      setMoneyFound(ecartAuto);
      setIsTyping(false);
    } else {
      setMoneyFound(value);
      setIsTyping(true);
    }
  };
  const user = useUser();
  const userInfo = user.result;

  // Same shape/pattern as Orders.jsx and Caisse_orders.jsx, so this renders
  // the exact same order-details modal.
  const handleViewDetails = (row) => {
    const firstCart = row._raw?.orders?.[0];
    if (!firstCart) return;
    const cartForModal = {
      ...firstCart,
      code: row.sessionCode,
      tableNumber: row._raw?.table?.table_number,
      payments: row._raw?.payments || [],
      session: {
        status: row._raw?.status,
        total_amount: row._raw?.total_amount,
        paid_amount: row._raw?.paid_amount,
        timbre: row._raw?.timbre,
        caissier_id: row._raw?.caissier,
        serveur_id: row._raw?.serveur,
        table_id: { table_number: row._raw?.table?.table_number },
      },
    };
    setDisplayedCart(cartForModal);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setDisplayedCart(null);
  };

  const handlePrint = () => {
    const printButton = document.getElementById("printButton");
    if (printButton) printButton.style.display = "none";
    window.print();
    if (printButton) printButton.style.display = "block";
  };

  const handleValidateJournal = async () => {
    swal({
      title: "Êtes-vous sûr ?",
      text: "Voulez-vous vraiment valider ce journal ?",
      icon: "warning",
      buttons: ["Annuler", "Oui, valider"],
      dangerMode: true,
    }).then(async (willValidate) => {
      if (willValidate) {
        console.log(journal);
        try {
          const res = await updateCashJournal(journal.id, {
            validator_id: userInfo.id,
            valide: true,
            ecart:
              parametrage && parametrage.clotureAllFund ? ecartAuto : ecart, // choose ecart
          });

          swal("Validé !", "Le journal a été validé avec succès.", "success");

          // optional: refresh data, close modal, etc.
        } catch (error) {
          console.error(error);
          swal(
            "Erreur !",
            "Une erreur est survenue lors de la validation.",
            "error",
          );
        }
      }
    });
  };

  return (
    <section className="content" style={{ padding: "5px 7px 0px 6px" }}>
      <GifLoader loading={loading} />

      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          .MuiBox-root, .MuiBox-root * {
            visibility: visible;
          }
          .MuiBox-root {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            max-width: 100%;
            box-shadow: none;
          }
        }
      `}</style>

      <div className="container-full">
        <div className="content-header">
          <div className="d-flex align-items-center">
            <h3
              onClick={() => console.log(journal)}
              className="page-title grid grid-cols-3 items-center"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              {/* Left */}
              <span className="text-left">{t("Journal ") + journal?.code}</span>

              {/* Center */}
              <span className="text-center">
                {formatDateAndTime(journal?.start_date)}
              </span>

              {/* Right */}
              <span className="text-right">
                {t("Ouvert par : ") + journal?.user_id?.nom}
              </span>
            </h3>
          </div>
        </div>

        <section className="content">
          {/* Orders Table */}
          <div className="row">
            <div className="col-12">
              <div className="box">
                <div className="box-body p-0">
                  <div className="table-responsive rounded card-table">
                    <table className="table border-no" id="orders-table">
                      <thead>
                        <tr>
                          <th>{t("Code")}</th>
                          {organisations[0].type === "Restaurant" && (
                            <th>{t("Table")}</th>
                          )}{" "}
                          <th>{t("Heure")}</th>
                          <th>{t("Type")}</th>
                          <th>{t("Caissier")}</th>
                          {organisations[0].type === "Restaurant" && (
                            <th>{t("Serveur")}</th>
                          )}{" "}
                          <th>{t("Client")}</th>
                          <th>{t("Total")}</th>
                          <th>{t("Encaissements ")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.length === 0 && !loading && (
                          <tr>
                            <td
                              colSpan={
                                organisations[0].type === "Restaurant" ? 8 : 6
                              }
                              className="text-center"
                            >
                              {t("Aucune donnée")}
                            </td>
                          </tr>
                        )}
                        {rows.map((row, index) => {
                          const time = formatDateAndTime(row.date);

                          // ── Credit payment row ──────────────────────────────────────────────
                          if (row._type === "credit_payment") {
                            return (
                              <tr
                                key={index}
                                style={{
                                  backgroundColor: "#fff8f5",
                                  borderLeft: "3px solid #e65100",
                                }}
                              >
                                <td>
                                  <small style={{ fontFamily: "monospace" }}>
                                    {t("Paiement crédit")}
                                  </small>
                                </td>

                                <td>{time}</td>
                                <td>
                                  <span
                                    className="badge"
                                    style={{
                                      backgroundColor: "#e65100",
                                      color: "#fff",
                                    }}
                                  >
                                    {t("Paiement crédit")}
                                  </span>
                                </td>
                                <td>{row.caissier}</td>
                                <td>
                                  <i
                                    className="fas fa-user mr-1"
                                    style={{ color: "#e65100" }}
                                  />
                                  {row.client}
                                </td>
                                <td>—</td>
                                <td>
                                  <strong style={{ color: "#2e7d32" }}>
                                    {row.amount?.toFixed(3)} {currency}
                                  </strong>
                                  <br />
                                  <small className="text-muted">
                                    {t(row.payment_method)}
                                  </small>
                                </td>
                              </tr>
                            );
                          }

                          // ── Session row (existing) ──────────────────────────────────────────
                          return (
                            <React.Fragment key={index}>
                              {/* 🔹 MAIN ROW */}
                              <tr>
                                <td
                                  onClick={() => handleViewDetails(row)}
                                  style={{
                                    cursor: "pointer",
                                    color: "#1f7a5a",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {row.sessionCode}
                                </td>
                                {organisations[0].type === "Restaurant" && (
                                  <td>
                                    <span className="badge badge-info">
                                      {row.table_number}
                                    </span>
                                  </td>
                                )}
                                <td onClick={() => console.log()}>
                                  {time}
                                  {/* <br />
                                  <small className="text-muted">{time}</small> */}
                                </td>
                                <td>
                                  <span className="badge badge-secondary">
                                    {t("Commande")}
                                  </span>
                                </td>
                                <td onClick={() => console.log(row)}>
                                  {row.caissier || "-"}
                                </td>
                                {organisations[0].type === "Restaurant" && (
                                  <td>{row.serveur || "-"}</td>
                                )}{" "}
                                <td>{row.client || "-"}</td>
                                <td>
                                  {row.amount?.toFixed(3)} {currency}
                                </td>
                                <td>
                                  {/* <strong>
                                    {row.amount?.toFixed(3)} {currency}
                                  </strong>
                                  <br />
                                  <small className="text-muted">
                                    {t(row.paymentMethod)}
                                  </small> */}
                                </td>
                              </tr>

                              {/* 🔹 SUB LINES (ORDERS) */}
                              {organisations[0].type === "Restaurant" &&
                                row.orders.map((order, i) => (
                                  <tr
                                    key={`${index}-order-${i}`}
                                    className="bg-light"
                                  >
                                    <td colSpan={2}>
                                      {" "}
                                      {/* unchanged */}
                                      <strong>{t("")}</strong> {order.numero}
                                    </td>
                                    <td colSpan={5}>
                                      {" "}
                                      {/* was 4, now 5 */}
                                      {formatDateAndTime(order.createdAt).time}
                                    </td>
                                    <td colSpan={2}>{order.prix}</td>
                                  </tr>
                                ))}
                              {row.payments.map((payment, i) => (
                                <>
                                  <tr
                                    key={`${index}-order-${i}`}
                                    className="bg-light"
                                  >
                                    <td
                                      colSpan={
                                        organisations[0].type === "Restaurant"
                                          ? 8
                                          : 6
                                      }
                                    ></td>
                                    <td>
                                      <strong>
                                        {payment.amount?.toFixed(3)} {currency}
                                      </strong>
                                      <br />
                                      <small className="text-muted">
                                        {t(payment.payment_method)}
                                      </small>{" "}
                                    </td>
                                  </tr>
                                  {payment.rendu > 0 ? (
                                    <tr
                                      key={`${index}-order-${i}`}
                                      className="bg-light"
                                    >
                                      <td
                                        colSpan={
                                          organisations[0].type === "Restaurant"
                                            ? 8
                                            : 6
                                        }
                                      ></td>
                                      <td>
                                        <strong className="text-primary">
                                          -{payment.rendu?.toFixed(3)}{" "}
                                          {currency}
                                        </strong>
                                        <br />
                                        <small className="text-primary">
                                          {t("Rendu")}
                                        </small>{" "}
                                      </td>
                                    </tr>
                                  ) : null}
                                </>
                              ))}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                    {journal && (
                      <div className="box mt-3">
                        <div className="box-body">
                          <h4 className="mb-3">{t("Récapitulatif caisse")}</h4>

                          <div className="row">
                            <div className="col-md-6">
                              <p>
                                {t("Total espèces")} :{" "}
                                <strong>
                                  {totals.cash.toFixed(3)} {currency}
                                </strong>
                              </p>
                              <p>
                                {t("Total cartes bancaires")} :{" "}
                                <strong>
                                  {totals.creditcard.toFixed(3)} {currency}
                                </strong>
                              </p>
                              <p>
                                {t("Total chèques")} :{" "}
                                <strong>
                                  {totals.cheque.toFixed(3)} {currency}
                                </strong>
                              </p>
                              <p>
                                {t("Total gift cards")} :{" "}
                                <strong>
                                  {totals.giftcard.toFixed(3)} {currency}
                                </strong>
                              </p>
                              <p>
                                {t("Paiements crédit")} :{" "}
                                <strong style={{ color: "#e65100" }}>
                                  {totals.credit_payment.toFixed(3)} {currency}
                                </strong>
                              </p>
                            </div>

                            <div className="col-md-6">
                              <p>
                                {t("Recette")} :{" "}
                                <strong>
                                  {totals.recette.toFixed(3)} {currency}
                                </strong>
                              </p>
                              <p>
                                {t("Fond initial")} :{" "}
                                <strong>
                                  {fondInitial.toFixed(3)} {currency}
                                </strong>
                              </p>
                              <p>
                                {t("Total caisse")} :{" "}
                                <strong>
                                  {totalCaisse.toFixed(3)} {currency}
                                </strong>
                              </p>
                              <p>
                                {t("Fond final")} :{" "}
                                <strong>
                                  {fondFinal.toFixed(3)} {currency}
                                </strong>
                              </p>
                              {journal &&
                                (() => {
                                  let value = 0;
                                  let show = false;

                                  if (!journal.valide && journal.cloture) {
                                    value = parametrage?.clotureAllFund
                                      ? ecartAuto
                                      : ecart;
                                    show = true;
                                  } else if (
                                    journal.valide &&
                                    journal.ecart !== 0
                                  ) {
                                    value = journal.ecart;
                                    show = true;
                                  }

                                  if (!show) return null;

                                  const valueClass =
                                    value >= 0
                                      ? "text-success"
                                      : "text-primary";
                                  const prefix = value > 0 ? "+" : "";

                                  return (
                                    <p>
                                      {t("Écart")} :{" "}
                                      <strong className={valueClass}>
                                        {prefix}
                                        {value.toFixed(3)} {currency}
                                      </strong>
                                    </p>
                                  );
                                })()}
                              {journal?.valide ? (
                                <p>
                                  {t("Validé par")} :{" "}
                                  <strong>
                                    {journal.validator_id.nom +
                                      " " +
                                      journal.validator_id.prenom}
                                  </strong>
                                </p>
                              ) : null}
                            </div>
                          </div>

                          <div className="row mt-3">
                            {!journal?.valide && journal?.cloture ? (
                              parametrage &&
                              journal &&
                              !parametrage.clotureAllFund ? (
                                <>
                                  <div className="col-10">
                                    <label className="form-label">
                                      {t("Montant trouvé")}
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={moneyFound}
                                      onKeyDown={handleKeyDown}
                                      onChange={handleMoneyFoundChange}
                                      step="0.01"
                                    />
                                  </div>
                                  <div className="col-2">
                                    <button
                                      className="btn btn-info"
                                      style={{
                                        position: "absolute",
                                        bottom: 0,
                                      }}
                                      onClick={handleValidateJournal}
                                    >
                                      {" "}
                                      {t("Valider")}{" "}
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <div className="col-12">
                                  <button
                                    className="btn btn-info"
                                    style={{ width: "100%" }}
                                    onClick={handleValidateJournal}
                                  >
                                    {" "}
                                    {t("Valider")}{" "}
                                  </button>
                                </div>
                              )
                            ) : null}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <OrderDetailsModal
        open={modalOpen}
        onClose={handleCloseModal}
        cart={displayedCart}
        currency={currency}
        t={t}
        onPrint={handlePrint}
      />
    </section>
  );
}

export default JournalCaisse;
